import { memo, useEffect } from 'react';

import { useTimestamp } from '../hooks';
import { useStore, useWorkflowStore } from '../store';
import { formatTimeFromNow } from '../utils';
import { useQuery } from '@umijs/max';
import { QUERY_KEYS } from '../../../type';
import { getTemplateDetail, renameTemplate } from '@/services/common';
import type { ITableTag, ITag } from '@/services/custom/extractConfig';

const EditingTitle = () => {
  const { formatTime } = useTimestamp();
  const store = useWorkflowStore();
  const draftUpdatedAt = useStore((state) => state.draftUpdatedAt);
  const isSyncingWorkflowDraft = useStore((s) => s.isSyncingWorkflowDraft);
  const templateCode = useStore((s) => s.template_code);

  const { data: templateDetail } = useQuery({
    queryKey: [
      QUERY_KEYS.WORKFLOW_CONFIG,
      getTemplateDetail.queryKey,
      templateCode,
    ],
    queryFn: ({ signal }) =>
      getTemplateDetail<{
        tags: {
          text_tags: ITag[];
          table_tags: ITableTag[];
        };
      }>(templateCode, signal),
    select: (res) => {
      if (res.code === 0) {
        return res.data;
      }
    },
    enabled: Boolean(templateCode),
    refetchOnWindowFocus: false,
  });

  // useEffect(() => {
  //   store.setState({ mode: 'edit' });
  // }, [store]);

  return (
    <div className="flex items-center h-[18px] text-xs text-gray-500">
      {templateDetail?.status !== 1 && Boolean(draftUpdatedAt) && (
        <>
          保存时间
          {formatTime(draftUpdatedAt / 1000, 'HH:mm:ss')}
          <span className="flex items-center mx-1">·</span>
        </>
      )}

      {templateDetail?.status === 1
        ? `已发布 ${templateDetail.operation_time}`
        : '未发布'}
      {isSyncingWorkflowDraft && (
        <>
          <span className="flex items-center mx-1">·</span>
          正在同步数据...
        </>
      )}
    </div>
  );
};

export default memo(EditingTitle);
